import React, { useMemo } from "react";

import FilterContainer from "core-web/containers/FilterContainer";
import ModulesLoading from "theme/libs/wordpress/content/ModulesLoading";
import PropTypes from "prop-types";
import config from "theme/config/filter";
import convertCmsFiltersToFilter from "core-web/utils/convertCmsFiltersToFilter";
// import convertSelectionToFilter from "core-web/utils/convertSelectionToFilter";
import loadable from "@loadable/component";
import useSaveResponse from "core-web/hooks/useSaveResponse";
import convertSelectionToFilter from "core-web/utils/convertSelectionToFilter";

const ListProducts = loadable(() => import("theme/components/ListProducts"), { fallback: <ModulesLoading /> });

const ProductGrid = ({ content, isManufacturer, isFirstModule, isLandingPage }) => {
    const {
        automatic_products_selection: productSelection,
        grid_content: gridContent,
        product_filters: productFilters,
        rule_contexts: ruleContexts,
        settings,
        filter_buttons: filterButtons = [],
    } = content.data || {};

    let isDistinct = true;

    const selectedCategoriesCode = content.data.norce_categories.map((cat) => cat.code);

    const selection = { categories: selectedCategoriesCode };

    const cmsSelection = convertSelectionToFilter(selection) || [];

    const cmsFilters = convertCmsFiltersToFilter(productFilters) || [];
    const mergedConfig = { ...config, ...cmsFilters };
    const hasCategoryFilter = productFilters?.find((filter) => filter.layout === "category_filter") || [];

    if (isManufacturer) {
        delete mergedConfig["manufacturer.name"];
    } else if (!hasCategoryFilter) {
        delete mergedConfig["categories.code"];
    }

    const campaignAreasLength = gridContent?.length || 0;
    const pageSize = parseInt(settings?.products_per_page || "24", 10);
    const firstPageSize = pageSize - campaignAreasLength * 2;

    // Save response from container
    const [savedResponse, saveResponse] = useSaveResponse();

    return useMemo(
        () => (
            <FilterContainer
                config={mergedConfig}
                distinct={isDistinct}
                filters={cmsSelection}
                firstPageSize={firstPageSize}
                pageSize={pageSize}
                ruleContexts={(ruleContexts || []).map((rule) => rule.value)}
                render={({ response }) => {
                    saveResponse(response);
                    return (
                        <ListProducts
                            isDistinct={isDistinct}
                            response={savedResponse.current}
                            config={mergedConfig}
                            isFirstModule={isFirstModule}
                            isLandingPage={isLandingPage}
                            gridContent={gridContent}
                            hasCategoryFilter={!!hasCategoryFilter}
                            filterButtons={filterButtons?.length ? filterButtons : []}
                        />
                    );
                }}
            />
        ),
        [
            JSON.stringify(cmsSelection),
            JSON.stringify(cmsFilters),
            JSON.stringify(savedResponse.current),
            isDistinct,
            isLandingPage,
            isManufacturer,
            isFirstModule,
        ],
    );
};

ProductGrid.propTypes = {
    content: PropTypes.object,
    isFirstModule: PropTypes.bool,
    isLandingPage: PropTypes.bool,
    isManufacturer: PropTypes.bool,
};

ProductGrid.defaultProps = {
    content: undefined,
    isFirstModule: false,
    isLandingPage: false,
    isManufacturer: false,
};

export default ProductGrid;
